


























































































































































































































import {
  Vue,
  Component,
  Watch,
  Prop
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import LoadingSpinner from "@/shared/components/ui/LoadingSpinner.vue";
import { AdvisorAction } from "@/admin/types";
import {
  AdvisorDelayPage,
  AdvisorDelayType,
  AdvisorDeliveryChannel,
  AdvisorDeliveryPage,
  AdvisorPreviewTemplateResponse,
  UserPermission
} from "@/shared/types";
import * as RouteNames from "@/admin/route-names";
import * as _ from "lodash";
import MediaUpload from "@/admin/components/advisor/MediaUpload.vue";
import { useAdvisorStore } from "@/admin/store/advisor";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

const initialState: AdvisorAction = {
  actionId: null,
  name: null,
  campaign: null,
  template: null,
  delayType: null,
  delayPage: AdvisorDelayPage.None,
  subjectTemplate: null,
  delayValue: null,
  priority: null,
  deliveryChannel: AdvisorDeliveryChannel.AdvisorPopup,
  deliveryPage: AdvisorDeliveryPage.None,
  mediaFiles: null,
  mediaFileNames: null,
  link: null,
  linkText: null,
  isRouteLink: true,
  isLinkTargetNew: false,
  testMode: false
};

@Component({
  components: {
    Button,
    Input,
    LoadingSpinner,
    MediaUpload
  }
})
export default class ActionEditor extends Vue {

  advisorStore = useAdvisorStore();
  rolePermissionStore = useRolePermissionsStore();
  featureFlagStore = useFeatureFlagStore();

  $validator: Validator;
  formModel: AdvisorAction = { ...initialState };
  isSubmitting = false;
  AdvisorDelayType = AdvisorDelayType;
  AdvisorDeliveryChannel = AdvisorDeliveryChannel;
  RouteNames = RouteNames;
  isModalVisible = false;
  isPreviewModalVisible = false;
  ruleToPreview = null;
  ruleAttributes = [];
  actionAttributes = [];
  isRuleEligible = false;
  selectedRuleId = null;
  testTemplateResults: AdvisorPreviewTemplateResponse[];
  linkType = [
    { text: "Page Name", value: true },
    { text: "Url", value: false }
  ];

  @Prop() actionId?: number;

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
        ? this.rolePermissionStore.userHasAdminPermission(UserPermission.AdminPortalAdvisorEdit)
        : true;
  }

  beforeMount () {
    this.$validator.extend("link", {
      getMessage: _ => {
        return "Both 'Link To/URL' and 'Link Title' need to be set as a pair.";
      },
      validate: _ => {
        return !this.formModel.link && !this.formModel.linkText || !!this.formModel.link && !!this.formModel.linkText;
      }
    });
    this.$validator.extend("validateUrl", {
      getMessage: _ => {
        return "Please enter a valid URL.";
      },
      validate: _ => {
        const result = { valid: true, data: { required: true } };

        if (this.formModel.isRouteLink) {
          return result;
        }

        if (!this.formModel.link) {
          result.valid = false;
          return result;
        }

        const url = this.formModel.link.toLowerCase().trim();
        if (url.indexOf("://") > 0) {
          try {
            const url = new URL(this.formModel.link as string);
          } catch {
            result.valid = false;
          }
        } else {
          result.valid = url.startsWith("/#/");
        }

        return result;
      }
    }, {
      computesRequired: true
    });
  }

  mounted () {
    this.load();
  }

  cancelDelete () {
    this.isModalVisible = false;
  }

  continueDelete (e) {
    e.preventDefault();
    if (!this.formModel.actionId) return;
    this.advisorStore.deleteAction(this.formModel.actionId)
        .then(() => {
          this.isModalVisible = false;
          this.formModel = { ...initialState };
          this.$router.push({ name: RouteNames.AdvisorActionList3 });
        });
  }

  showModal () {
    this.isModalVisible = true;
  }

  cancelPreview () {
    this.isPreviewModalVisible = false;
  }

  showPreviewModal () {
    this.ruleAttributes = [];
    const allAttributes = [];
    let templateAttributes = [];
    const templateCleanupRegex = /{{[{]?(.*?)[}]?}}/g;
    const attributeStartsWith = "{{attributes.";
    const attributeEndsWith = "}}";
    this.advisorStore.resetPreviewTemplateResult();
    if (this.formModel.template !== null) {
      templateAttributes = this.formModel.template.toLowerCase().match(templateCleanupRegex);
    }
    let subjectTemplateAttributes = [];
    if (this.formModel.subjectTemplate !== null) {
      subjectTemplateAttributes = this.formModel.subjectTemplate.toLowerCase().match(templateCleanupRegex);
    }

    if (templateAttributes !== null) {
      for (let i = 0; i < templateAttributes.length; ++i) {
        if (templateAttributes[i].startsWith(attributeStartsWith)) {
          allAttributes[i] = templateAttributes[i].replace(attributeStartsWith, "").replace(attributeEndsWith, "");
        }
      }
    }
    if (subjectTemplateAttributes !== null) {
      for (let i = 0; i < subjectTemplateAttributes.length; ++i) {
        if (subjectTemplateAttributes[i].startsWith(attributeStartsWith)) {
          allAttributes[allAttributes.length + i]
              = subjectTemplateAttributes[i].replace(attributeStartsWith, "").replace(attributeEndsWith, "");
        }
      }
    }
    // remove duplicates
    this.actionAttributes = [ ...new Set(allAttributes) ];
    this.advisorStore.loadAllRules();
    this.isPreviewModalVisible = true;
  }

  rulesToDisplay () {
    return this.advisorStore.rules;
  }

  onRuleSelected (rule) {
    this.ruleAttributes = [];
    this.ruleToPreview = rule;
    this.isRuleEligible = true;
    this.selectedRuleId = rule.id;
    this.advisorStore.resetPreviewTemplateResult();

    const cleanQuery = rule.query.toLowerCase().replace("/\r?\n|\r/", "");
    // starting after select (length 6) clause
    const attributes = cleanQuery.substring(6, cleanQuery.indexOf("from")).split(",");

    // aliases are removed for clean comparison
    if (attributes !== null) {
      for (let i = 0; i < attributes.length; i++) {
        this.ruleAttributes[i] = attributes[i];
        const indexOfAlias = attributes[i].indexOf(".");
        if (indexOfAlias > 0) {
          this.ruleAttributes[i] = attributes[i].substring(indexOfAlias + 1);
        }
      }
    }
    // check if the rule returns required action template attributes
    if (this.actionAttributes !== null && this.actionAttributes.length > 0) {
      this.actionAttributes.forEach(aattr => {
        const index = this.ruleAttributes.findIndex(x => x.trim() === aattr.toLowerCase());
        if (index === -1) {
          this.isRuleEligible = false;
        }
      });
    }
  }

  actionPreview () {
    this.advisorStore.previewTemplate({ actionId: this.actionId, ruleId: this.selectedRuleId });
  }

  linkTypeChanged () {
    this.formModel.link = null;
  }

  get hasId () {
    return !!this.formModel.actionId;
  }

  @Watch("actionId")
  onActionIdChange () {
    this.load();
  }

  @Watch("advisorStore.action")
  onActionStateChanged () {
    if (this.advisorStore.isActionLoaded && this.advisorStore.action) {
      this.cloneToCurrentModel(this.advisorStore.action);
    }
  }

  load () {
    if (this.actionId) {
      this.advisorStore.loadAction(this.actionId);
    }
  }

  cloneToCurrentModel (o) {
    const clonedModel = _.cloneDeep(o);
    this.formModel = clonedModel;
  }

  addFiles (files) {
    this.formModel.mediaFiles = files;
  }

  createDownloadLink (fileName) {
    this.advisorStore.mediaGetLink({
      actionId: this.actionId,
      fileName
    });
  }

  removeMedia (fileName) {
    this.advisorStore.mediaRemove({
      actionId: this.actionId,
      fileName
    });
  }

  get showDelayValue () {
    return this.formModel.delayType === AdvisorDelayType.DayCount
        || this.formModel.delayType === AdvisorDelayType.LoginCount
        || this.formModel.delayType === AdvisorDelayType.PageViewCount;
  }

  get showDelayPage () {
    return this.formModel.delayType === AdvisorDelayType.PageViewCount;
  }

  get IsDeliveryChannelPopup () {
    const value = this.formModel.deliveryChannel === AdvisorDeliveryChannel.AdvisorPopup;
    if (!value) {
      this.formModel.deliveryPage = AdvisorDeliveryPage.None;
      this.formModel.link = null;
      this.formModel.linkText = null;
    }
    return value;
  }

  get isLoaded () {
    return !this.advisorStore.action || this.advisorStore.isActionLoaded;
  }

  get isSubmitEnabled (): boolean {
    return (
        !this.isSubmitting
    );
  }

  onSubmit () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      if (this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      this.advisorStore.saveAction({ ...this.formModel }).then(resp => {
        this.isSubmitting = false;
        this.$router.push({ name: RouteNames.AdvisorAction, params: { actionId: resp } });
      });
    });
  }
}
